import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import CustomReveal from '../../common/reveal/CustomReveal';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import PropTypes from 'prop-types';
import CustomButton from '../../common/CustomButton';
import injectSheet from 'react-jss';

const styles = {
  showAllColor: {
    color: props => props.colors.btnText,
    '&:hover': {
      color: props => props.colors.btnTextHover
    }
  }
};

class FailImportStudentsReveal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.closeFailImportCSVModal = this.closeFailImportCSVModal.bind(this);
    this.showAllStudents = this.showAllStudents.bind(this);
    this.state = {
      seeAll: false
    };
  }

  static propTypes = {
    active: PropTypes.bool
  };

  closeFailImportCSVModal() {
    const { classroomActions } = this.props;
    this.setState(
      {
        seeAll: false
      },
      () => {
        classroomActions.setFailImportCSVModalState(false);
      }
    );
  }

  showAllStudents() {
    this.setState({
      seeAll: true
    });
  }

  renderStudents() {
    const { studentsErrors, classes } = this.props;
    const { seeAll } = this.state;

    const students = studentsErrors.map((studentError, i) => {
      if (seeAll || i < 3) return <div key={studentError.index}>{studentError.student.name}</div>;
      return undefined;
    });

    const seeAllButton =
      !seeAll && studentsErrors.length > 3 ? (
        <div>
          <p className="ellipsis">...</p>
          <button className={`see-all-btn ${classes.showAllColor}`} onClick={this.showAllStudents}>
            {I18n.t('common.showAll')}
          </button>
        </div>
      ) : (
        undefined
      );

    return (
      <div>
        {students}
        {seeAllButton}
      </div>
    );
  }

  render() {
    const { active, reconnect, colors } = this.props;

    return (
      <CustomReveal id="fail-import-csv" active={active} close={this.closeFailImportCSVModal}>
        <div className="content">
          <img alt="" src={reconnect} />
          <div className="info">
            <span>{I18n.t('importStudentsPopup.errorText')}</span>
          </div>
          <div className="students">{this.renderStudents()}</div>
          <CustomButton
            onClick={this.closeFailImportCSVModal}
            color={colors.btnSuccess}
            colorHover={colors.btnSuccessHover}
            className="button"
            value={I18n.t('common.accept')}
          />
        </div>
      </CustomReveal>
    );
  }
}

function mapStateToProps(state) {
  return {
    classroom: state.classrooms.selectedClassroom.classroom,
    active: state.classrooms.failImportCSVModalIsOpen,
    studentsErrors: state.classrooms.studentsErrors,
    i18n: state.i18n,
    colors: state.theme.colors,
    reconnect: state.theme.images.icons.reconnect
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(FailImportStudentsReveal));
